export default __webpack_public_path__ + "static/media/lock.ed03a662.svg";